var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { reactive, onMounted, onUnmounted, computed } from "vue";
const dataName = "data-overlay-mask", overlayMaskStore = reactive({ length: 0 });
function useOverlayMask() {
  function changeClass() {
    const elements = Array.from(document.querySelectorAll(`[${dataName}]`));
    elements.at(-1) && elements.at(-1).style.removeProperty("display");
    for (let i = elements.length - 2; i >= 0; i--)
      elements[i].style.display = "none";
  }
  return __name(changeClass, "changeClass"), onMounted(() => {
    changeClass(), overlayMaskStore.length += 1;
  }), onUnmounted(() => {
    changeClass(), overlayMaskStore.length -= 1;
  }), {
    attribute: {
      [dataName]: "true"
    },
    // 是否需要添加进出动画
    needAnimateIn: computed(() => overlayMaskStore.length === 0),
    needAnimateOut: computed(() => overlayMaskStore.length === 1)
  };
}
__name(useOverlayMask, "useOverlayMask");
export {
  useOverlayMask
};
//# sourceMappingURL=useOverlay.js.map
